export default __webpack_public_path__ + "static/media/DaimlerCS-Light.860b3f9e.eot";